module.exports = __webpack_public_path__ + "56a9e9bd5e20b4dd6d4a0fba59b4aca2.svg";